import Utils from "../../utils/Utils";

export default {

    init() {

        const DEBOUNCE_MILLIS = 500;

        const DATA_INVOICE_ITEM_ID = "invoice-item-id";
        const DATA_PRODUCT_ID = "product-id";

        let _invoice = null;

        function invoiceLoaded(invoice) {
            _invoice = invoice;

            $(TSF_BTN_FILTER_SUBMIT).attr('disabled', false);

            //loadSelectableProducts(invoice.id);
            loadInvoiceItems(invoice.id);
            invoiceAccountingLoaded(invoice.accounting);
        }

        function loadInvoice(invoice_id) {

            httpRequest.get(`admin/content/api/invoices/${invoice_id}`)
                .then(response => invoiceLoaded(response.data.data))
                .catch(error => {
                });
        }

        loadInvoice(INVOICE_ID);

        const TAB_LINK_DETAILS = "#tab-link-details";
        const TAB_LINK_CII = "#tab-link-cii";

        const TABLE_DETAILS = "#table-details";
        const TABLE_DETAILS_BODY = "#table-details tbody";

        const TD_INPUT_DISCOUNT = ".td-input-discount";
        const TD_INPUT_VAT = ".td-input-vat";

        const TD_BTN_EDIT = ".td-btn-edit";
        const TD_BTN_DESTROY = ".td-btn-destroy";

        const TD_INVOICE_TAXABLE = "#td-invoice-taxable";
        const TD_INVOICE_DISCOUNT = "#td-invoice-discount";
        const TD_INVOICE_TAX = "#td-invoice-tax";
        const TD_INPUT_INVOICE_SHIPPING_FEES = "#td-input-invoice-shipping-fees";
        const TD_INVOICE_TOTAL = "#td-invoice-total";

        function invoiceItemsLoaded(invoice_items) {
            $(TABLE_DETAILS_BODY).html(invoice_items);
            getInvoiceAccounting(_invoice.id);
        }

        function loadInvoiceItems(invoice_id) {

            const params = {
                wants_html: true,
            };

            httpRequest.get(`admin/content/api/invoices/${invoice_id}/get-invoice-items`, {
                params: params
            }).then(response => invoiceItemsLoaded(response.data.data))
                .catch(error => {
                });
        }

        function invoiceAccountingLoaded(accounting) {

            $(TD_INVOICE_TAXABLE).text(numeral(accounting.taxable).format('0,0.00'));
            $(TD_INVOICE_DISCOUNT).text(numeral(accounting.discount).format('0,0.00'));
            $(TD_INVOICE_TAX).text(numeral(accounting.tax).format('0,0.00'));
            $(TD_INPUT_INVOICE_SHIPPING_FEES).val(accounting.shipping_fees);
            $(TD_INVOICE_TOTAL).text(numeral(accounting.total).format('0,0.00'));
        }

        function getInvoiceAccounting(invoice_id) {

            httpRequest.get(`admin/content/api/invoices/${invoice_id}/get-accounting`)
                .then(response => invoiceAccountingLoaded(response.data.data))
                .catch(error => {
                });
        }

        function setInvoiceShippingFees(invoice_id, shipping_fees) {

            const data = {
                shipping_fees: shipping_fees,
            };

            httpRequest.put(`admin/content/api/invoices/${invoice_id}/set-invoice-shipping-fees`, data)
                .then(response => invoiceAccountingLoaded(response.data.data))
                .catch(error => {
                });
        }

        $(TD_INPUT_INVOICE_SHIPPING_FEES).on('change', function (e) {
            const shipping_fees = $(this).val();
            setInvoiceShippingFees(_invoice.id, shipping_fees);
        });

        $(TD_INPUT_INVOICE_SHIPPING_FEES).on('keyup', underscore.debounce(function (e) {
            const shipping_fees = $(this).val();
            setInvoiceShippingFees(_invoice.id, shipping_fees);
        }, DEBOUNCE_MILLIS));

        function setInvoiceItemDiscount(invoice_id, invoice_item_id, discount) {

            const data = {
                discount: discount,
            };

            httpRequest.put(`admin/content/api/invoices/${invoice_id}/${invoice_item_id}/set-invoice-item-discount`, data)
                .then(response => loadInvoiceItems(invoice_id))
                .catch(error => {
                });
        }

        function setInvoiceItemVat(invoice_id, invoice_item_id, vat) {

            const data = {
                vat: vat,
            };

            httpRequest.put(`admin/content/api/invoices/${invoice_id}/${invoice_item_id}/set-invoice-item-vat`, data)
                .then(response => loadInvoiceItems(invoice_id))
                .catch(error => {
                });
        }

        $(TABLE_DETAILS_BODY).on('change', TD_INPUT_DISCOUNT, function (e) {
            const discount = $(this).val();
            const invoice_item_id = $(this).data(DATA_INVOICE_ITEM_ID);
            setInvoiceItemDiscount(_invoice.id, invoice_item_id, discount);
        });

        $(TABLE_DETAILS_BODY).on('keyup', TD_INPUT_DISCOUNT, underscore.debounce(function (e) {
            const discount = $(this).val();
            const invoice_item_id = $(this).data(DATA_INVOICE_ITEM_ID);
            setInvoiceItemDiscount(_invoice.id, invoice_item_id, discount);
        }, DEBOUNCE_MILLIS));

        $(TABLE_DETAILS_BODY).on('change', TD_INPUT_VAT, function (e) {
            const vat = $(this).val();
            const invoice_item_id = $(this).data(DATA_INVOICE_ITEM_ID);
            setInvoiceItemVat(_invoice.id, invoice_item_id, vat);
        });

        $(TABLE_DETAILS_BODY).on('keyup', TD_INPUT_VAT, underscore.debounce(function (e) {
            const vat = $(this).val();
            const invoice_item_id = $(this).data(DATA_INVOICE_ITEM_ID);
            setInvoiceItemVat(_invoice.id, invoice_item_id, vat);
        }, DEBOUNCE_MILLIS));

        function loadInvoiceItem(invoice_id, invoice_item_id, callback) {

            httpRequest.get(`admin/content/api/invoices/${invoice_id}/${invoice_item_id}/get-invoice-item`)
                .then(response => (callback && typeof callback === "function") ? callback(response.data.data) : {})
                .catch(error => {
                });
        }

        $(TABLE_DETAILS_BODY).on('click', TD_BTN_EDIT, function (e) {
            e.preventDefault();

            const invoice_item_id = $(this).data(DATA_INVOICE_ITEM_ID);

            loadInvoiceItem(_invoice.id, invoice_item_id, fillCreateInvoiceItemFormDataAndShowTab);

        });

        function invoiceItemDestroyed() {
            loadInvoiceItems(_invoice.id)
            loadSelectableProducts(_invoice.id);
        }

        function destroyInvoiceItem(invoice_id, invoice_item_id) {

            httpRequest.delete(`admin/content/api/invoices/${invoice_id}/${invoice_item_id}/destroy-invoice-item`)
                .then(response => invoiceItemDestroyed())
                .catch(error => {
                });
        }

        $(TABLE_DETAILS_BODY).on('click', TD_BTN_DESTROY, function (e) {
            e.preventDefault();

            if (confirm("Vuoi veramente eliminare l'elemento selezionato?")) {
                const invoice_item_id = $(this).data(DATA_INVOICE_ITEM_ID);
                destroyInvoiceItem(_invoice.id, invoice_item_id);
            }
        });

        const CII_INPUT_DESCRIPTION = "#cii-input-description";
        const CII_INPUT_AMOUNT = "#cii-input-amount";
        const CII_BTN_SUBMIT = "#cii-btn-submit";

        function getCreateInvoiceItemFormData() {

            return {
                description: $(CII_INPUT_DESCRIPTION).val(),
                amount: $(CII_INPUT_AMOUNT).val(),
            }
        }

        function clearCreateInvoiceItemFormData() {

            $(CII_INPUT_DESCRIPTION).val('');
            $(CII_INPUT_AMOUNT).val('');
            $(CII_BTN_SUBMIT).data(DATA_INVOICE_ITEM_ID, "");
        }

        function fillCreateInvoiceItemFormData(invoice_item) {
            clearCreateInvoiceItemFormData();
            $(CII_INPUT_DESCRIPTION).val(invoice_item.description);
            $(CII_INPUT_AMOUNT).val(invoice_item.amount);
            $(CII_BTN_SUBMIT).data(DATA_INVOICE_ITEM_ID, invoice_item.id);
        }

        function fillCreateInvoiceItemFormDataAndShowTab(invoice_item) {
            fillCreateInvoiceItemFormData(invoice_item);
            $(TAB_LINK_CII).tab("show");
        }

        function invoiceItemCreated(invoice_item) {
            clearCreateInvoiceItemFormData();
            loadInvoiceItems(invoice_item.invoice_id);
            loadSelectableProducts(invoice_item.invoice_id);
            $(TAB_LINK_DETAILS).tab('show');
        }

        function storeInvoiceItem(invoice_id, data) {

            httpRequest.post(`admin/content/api/invoices/${invoice_id}/store-invoice-item`, data)
                .then(response => invoiceItemCreated(response.data.data))
                .catch(error => {

                });
        }

        function updateInvoiceItem(invoice_id, invoice_item_id, data) {
            httpRequest.put(`admin/content/api/invoices/${invoice_id}/${invoice_item_id}/update-invoice-item`, data)
                .then(response => invoiceItemCreated(response.data.data))
                .catch(error => {

                });
        }

        $(CII_BTN_SUBMIT).click(function (e) {
            e.preventDefault();

            const invoice_item_id = $(this).data(DATA_INVOICE_ITEM_ID);

            if (Utils.isEmpty(invoice_item_id)) {
                storeInvoiceItem(_invoice.id, getCreateInvoiceItemFormData());
            } else {
                updateInvoiceItem(_invoice.id, invoice_item_id, getCreateInvoiceItemFormData());
            }
        });

        function getTableOrder(e) {

            const order = [];

            const children = $(e.target).children();

            for (const child of children) {
                const invoice_item_id = $(child).data(DATA_INVOICE_ITEM_ID);

                if (!Utils.isEmpty(invoice_item_id)) {
                    order.push(invoice_item_id);
                }
            }

            return order;
        }

        function sortInvoiceItems(e, ui) {

            const order = getTableOrder(e);

            const target = $(e.target);

            target.sortable('disable');

            const data = {
                invoice_items: order,
            };

            httpRequest.post(`admin/content/api/invoices/${_invoice.id}/sort-invoice-items`, data)
                .then(response => invoiceItemsLoaded(response.data.data)).catch(error => {
                target.sortable('cancel');
            }).finally(function () {
                target.sortable('enable');
            });
        }

        function fixWidthHelper(e, ui) {

            ui.children().each(function () {
                $(this).width($(this).width());
            });

            return ui;
        }

        $(TABLE_DETAILS_BODY).sortable({
            helper: fixWidthHelper,
            stop: sortInvoiceItems,
            handle: '.sort-handle'
        });

        const TABLE_SELECT = "#table-select";
        const TABLE_SELECT_BODY = "#table-select tbody"

        const INPUT_PRICE = ".input-price";
        const BTN_ASSOCIATE = ".btn-associate";

        const TSF_INPUT_FILTER_PURCHASING_CHANNEL_TYPE = "#tsf-input-purchasing-channel-type";
        const TSF_INPUT_FILTER_PRODUCT_TYPE = "#tsf-input-product-type";
        const TSF_INPUT_FILTER_PRODUCT_CODE = "#tsf-input-product-code";
        const TSF_INPUT_FILTER_PROTOCOL_NUMBER = "#tsf-input-protocol-number";
        const TSF_INPUT_FILTER_PURCHASING_CHANNEL_ID = "#tsf-input-purchasing-channel-id";
        const TSF_INPUT_FILTER_SALES_CHANNEL_ID = "#tsf-input-sales-channel-id";
        const TSF_INPUT_FILTER_ORDER_EXTERNAL = "#tsf-input-order-external";
        const TSF_INPUT_FILTER_DESCRIPTION = "#tsf-input-description";
        const TSF_INPUT_FILTER_NOTES = "#tsf-input-notes";
        const TSF_BTN_FILTER_SUBMIT = "#tsf-btn-submit";

        function getTableSelectFilterData() {

            return {
                purchasing_channel_type: $(TSF_INPUT_FILTER_PURCHASING_CHANNEL_TYPE).val(),
                product_type: $(TSF_INPUT_FILTER_PRODUCT_TYPE).val(),
                product_code: $(TSF_INPUT_FILTER_PRODUCT_CODE).val(),
                protocol_number: $(TSF_INPUT_FILTER_PROTOCOL_NUMBER).val(),
                purchasing_channel_id: $(TSF_INPUT_FILTER_PURCHASING_CHANNEL_ID).val(),
                sales_channel_id: $(TSF_INPUT_FILTER_SALES_CHANNEL_ID).val(),
                order_external: $(TSF_INPUT_FILTER_ORDER_EXTERNAL).val(),
                description: $(TSF_INPUT_FILTER_DESCRIPTION).val(),
                notes: $(TSF_INPUT_FILTER_NOTES).val(),
            }
        }

        function selectableProductLoaded(selectable_products) {
            $(TABLE_SELECT_BODY).html(selectable_products);
        }

        function loadSelectableProducts(invoice_id) {

            const params = getTableSelectFilterData();
            params['wants_html'] = true;

            httpRequest.get(`admin/content/api/invoices/${invoice_id}/get-selectable-products`, {
                params: params,
            })
                .then(response => selectableProductLoaded(response.data.data))
                .catch(error => {
                })
        }

        $(TABLE_SELECT_BODY).on('click', BTN_ASSOCIATE, function (e) {
            e.preventDefault();

            const product_id = $(this).data(DATA_PRODUCT_ID);

            const input_price = $(TABLE_SELECT_BODY).find(`${INPUT_PRICE}[data-product-id=${product_id}]`);

            const price = input_price.val();

            const data = {
                product_id: product_id,
                amount: price,
            }

            storeInvoiceItem(_invoice.id, data);
        });

        $(TSF_BTN_FILTER_SUBMIT).click(function (e) {
            e.preventDefault();
            loadSelectableProducts(_invoice.id);
        });
    },

    finalize() {

    },
}
